import * as React from "react";
import * as ReactDOM from "react-dom";
import {
  Html
} from "../../../../components";
import * as styles from "../../styles.scss";
import { tl } from "../../../../utils";

interface IEquallyProps {
  value: any;
}

export const Equally = (props: IEquallyProps) => {
  return (
    <div className={styles.answerBlock}>
      <span className={styles.answerTitleInline}>{tl('Ответ.')}</span>
      <Html>{props.value.content}</Html>
    </div>
  );
};
